(() => {
  'use strict';

  const config = window.SAKE_LIMIT_ONE;

  if (!config || !config.productId || !config.handle) {
    return;
  }

  const productId = Number(config.productId);
  const variantIds = new Set(
    (config.variantIds || []).map((id) => Number(id))
  );

  const message =
    config.message || 'こちらの商品はお一人様1本限りです。';

  const root = String(config.root || '/').replace(/\/?$/, '/');
  const productPath = `/products/${config.handle}`;

  let adding = false;

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('カートを取得できませんでした。');
    }

    return response.json();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('カートを変更できませんでした。');
    }

    return response.json();
  };

  const enforceLimit = async () => {
    const cart = await getCart();

    const targetItems = cart.items.filter(
      (item) => Number(item.product_id) === productId
    );

    const total = targetItems.reduce(
      (sum, item) => sum + Number(item.quantity || 0),
      0
    );

    if (total <= 1) {
      return {
        count: total,
        changed: false
      };
    }

    let firstItem = true;

    for (const item of targetItems) {
      const newQuantity = firstItem ? 1 : 0;
      firstItem = false;

      if (Number(item.quantity) !== newQuantity) {
        await changeLine(item.key, newQuantity);
      }
    }

    return {
      count: 1,
      changed: true
    };
  };

  const isTargetForm = (form) => {
    if (!(form instanceof HTMLFormElement)) {
      return false;
    }

    const action = form.getAttribute('action') || '';

    if (!action.includes('/cart/add')) {
      return false;
    }

    const variantInput = form.querySelector('[name="id"]');
    const variantId = Number(variantInput?.value);

    return variantIds.has(variantId);
  };

  const isTargetProductPage = () => {
    const currentPath = location.pathname.replace(/\/$/, '');
    return currentPath.endsWith(productPath);
  };

  const getTargetCartRow = (element) => {
    const row = element?.closest(
      'cart-item, .cart-item, [data-cart-item], tr, li'
    );

    if (!row) {
      return null;
    }

    const productLink = row.querySelector(
      `a[href*="${productPath}"]`
    );

    return productLink ? row : null;
  };

  const lockScreen = () => {
    if (isTargetProductPage()) {
      document
        .querySelectorAll('form[action*="/cart/add"]')
        .forEach((form) => {
          if (!isTargetForm(form)) {
            return;
          }

          const quantityInput = form.querySelector(
            'input[name="quantity"]'
          );

          if (quantityInput) {
            quantityInput.value = '1';
            quantityInput.min = '1';
            quantityInput.max = '1';
            quantityInput.readOnly = true;

            const quantityArea =
              quantityInput.closest('.product-form__quantity') ||
              quantityInput.closest('quantity-input') ||
              quantityInput.closest('.quantity');

            if (quantityArea) {
              quantityArea.style.display = 'none';
            }
          }
        });

      document
        .querySelectorAll('.shopify-payment-button')
        .forEach((button) => {
          button.style.display = 'none';
        });
    }

    document
      .querySelectorAll(`a[href*="${productPath}"]`)
      .forEach((link) => {
        const row = getTargetCartRow(link);

        if (!row) {
          return;
        }

        const quantityInput = row.querySelector(
          'input[name="updates[]"], input.quantity__input'
        );

        if (quantityInput) {
          quantityInput.max = '1';
        }

        row
  .querySelectorAll('button[name="plus"]')
  .forEach((button) => {
    button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.title = message;
  });
      });
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!isTargetForm(form)) {
        return;
      }

      const quantityInput = form.querySelector(
        'input[name="quantity"]'
      );

      if (quantityInput) {
        quantityInput.value = '1';
      }

      if (form.dataset.limitOneApproved === 'true') {
        delete form.dataset.limitOneApproved;

        window.setTimeout(() => {
          adding = false;
        }, 2500);

        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (adding) {
        alert(message);
        return;
      }

      adding = true;

      const submitter = event.submitter;

      try {
        const result = await enforceLimit();

        if (result.count >= 1) {
          alert(message);
          adding = false;
          return;
        }

        form.dataset.limitOneApproved = 'true';
        form.requestSubmit(submitter || undefined);
      } catch (error) {
        console.error('[SAKE_LIMIT_ONE]', error);

        alert(
          'カートを確認できませんでした。ページを再読み込みしてください。'
        );

        adding = false;
      }
    },
    true
  );

  document.addEventListener(
  'click',
  (event) => {
    const plusButton = event.target.closest(
      'button[name="plus"]'
    );

    if (!plusButton) {
      return;
    }

    /*
     * 対象の商品ページにある数量「＋」ボタン
     */
    if (isTargetProductPage()) {
      const quantityArea = plusButton.closest(
        'quantity-input, .quantity'
      );

      const quantityInput = quantityArea?.querySelector(
        'input[name="quantity"]'
      );

      if (quantityInput) {
        event.preventDefault();
        event.stopImmediatePropagation();

        quantityInput.value = '1';
        quantityInput.min = '1';
        quantityInput.max = '1';

        alert(message);
        return;
      }
    }

    /*
     * カート画面・カートドロワーの数量「＋」ボタン
     */
    const row = getTargetCartRow(plusButton);

    if (!row) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    alert(message);
  },
  true
);

  document.addEventListener(
    'change',
    (event) => {
      const quantityInput = event.target.closest(
        'input[name="updates[]"], input.quantity__input'
      );

      if (!quantityInput) {
        return;
      }

      const row = getTargetCartRow(quantityInput);

      if (!row || Number(quantityInput.value) <= 1) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      quantityInput.value = '1';

      alert(message);
    },
    true
  );

  const start = async () => {
    lockScreen();

    if (
      isTargetProductPage() ||
      location.pathname.includes('/cart')
    ) {
      try {
        const result = await enforceLimit();

        if (
  result.changed &&
  location.pathname.includes('/cart')
) {
  alert(message);
  location.reload();
  return;
}
      } catch (error) {
        console.error('[SAKE_LIMIT_ONE]', error);
      }
    }

    let timer;

    new MutationObserver(() => {
      clearTimeout(timer);

      timer = window.setTimeout(() => {
        lockScreen();
      }, 100);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();